<template>
    <div class="main-container">
        <!-- Navbar section -->
        <Navbar/>

        <!-- hero section -->
        <Hero/>

        <ContentBanner link="/knowledge/chatgpt-alternatives" :image="require('../assets/img/trustami/chatgpt_alternatives.svg')">
            <template #header>{{ $t("knowledge.chatgpt_alternatives") }}</template>
            <template #main>
                {{ $t("knowledge.chatgpt_alternatives_preview") }}
            </template>
        </ContentBanner>

        <ContentBanner link="/knowledge/summarization" :image="require('../assets/img/trustami/summarization.svg')" :rightAlign="true">
            <template #header>{{ $t("knowledge.summarization") }}</template>
            <template #main>
                {{ $t("knowledge.summarization_preview") }}
            </template>
        </ContentBanner>

        <ContentBanner link="/knowledge/tokenization" :image="require('../assets/img/trustami/tokenization.svg')">
            <template #header>{{ $t("knowledge.tokenization") }}</template>
            <template #main>
                {{ $t("knowledge.tokenization_preview") }}
            </template>
        </ContentBanner>

        <ContentBanner link="/knowledge/sentiment-api" :image="require('../assets/img/trustami/sentiment_blog.svg')" :rightAlign="true">
            <template #header>{{ $t("knowledge.sentiment_api") }}</template>
            <template #main>
                {{ $t("knowledge.sentiment_api_preview") }}
            </template>
        </ContentBanner>

        <ContentBanner link="/knowledge/keyword" :image="require('../assets/img/trustami/keyword.svg')">
            <template #header>{{ $t("knowledge.keyword") }}</template>
            <template #main>
                {{ $t("knowledge.keyword_preview") }}
            </template>
        </ContentBanner>

        <ContentBanner link="/knowledge/language-detection" :image="require('../assets/img/trustami/language_blog.svg')" :rightAlign="true">
            <template #header>{{ $t("knowledge.language_detection") }}</template>
            <template #main>
                {{ $t("knowledge.language_detection_preview") }}
            </template>
        </ContentBanner>

        <ContentBanner link="/knowledge/entity-recognition" :image="require('../assets/img/trustami/entity_recognition.svg')">
            <template #header>{{ $t("knowledge.entity_recognition") }}</template>
            <template #main>
                {{ $t("knowledge.entity_recognition_preview") }}
            </template>
        </ContentBanner>

        <!-- footer section -->
        <FooterMain/>

    </div>
</template>

<script>
import Hero from '../comp_trustami/Knowledge/Hero';
import ContentBanner from '../comp_trustami/Knowledge/ContentBanner';
import FooterMain from '../comp_trustami/FooterMain';
import Navbar from "../comp_trustami/NavbarSub";

export default {
    name: 'app',
    components: {
        Navbar,
        Hero,
        ContentBanner,
        FooterMain,
    },

    metaInfo: {
        title: 'Knowledge - Trustami.AI Web Services',
        meta: [
            {
                name: 'description',
                content: 'Cutting-edge Machine Learning Research Projects.'
            }
        ],
        htmlAttrs: {
            lang: 'en',
            amp: true
        }
    }
}
</script>
